<template>
  <section class="panel chart-panel">
    <div class="panel-header">
      <div>
        <h2>{{ title }}</h2>
        <p v-if="subtitle">{{ subtitle }}</p>
      </div>
    </div>
    <div class="chart-frame">
      <canvas ref="canvas"></canvas>
    </div>
  </section>
</template>

<script setup>
import { Chart, registerables } from 'chart.js';
import { onBeforeUnmount, onMounted, ref, watch } from 'vue';

Chart.register(...registerables);

const props = defineProps({
  title: { type: String, required: true },
  subtitle: { type: String, default: '' },
  type: { type: String, default: 'bar' },
  data: { type: Object, required: true },
  options: { type: Object, default: () => ({}) }
});

const canvas = ref(null);
let chart = null;

onMounted(render);
onBeforeUnmount(() => chart?.destroy());

watch(
  () => [props.type, props.data, props.options],
  () => render(),
  { deep: true }
);

function render() {
  if (!canvas.value) return;
  chart?.destroy();
  chart = new Chart(canvas.value, {
    type: props.type,
    data: props.data,
    options: {
      responsive: true,
      maintainAspectRatio: false,
      animation: false,
      plugins: {
        legend: {
          display: props.type !== 'bar' && props.type !== 'line',
          labels: { boxWidth: 12, color: '#172033' }
        },
        tooltip: {
          mode: 'index',
          intersect: false
        }
      },
      scales: props.type === 'doughnut' ? undefined : {
        x: {
          ticks: { color: '#5c667a', maxRotation: 0, autoSkip: true },
          grid: { display: false }
        },
        y: {
          beginAtZero: true,
          ticks: { color: '#5c667a' },
          grid: { color: 'rgba(23, 32, 51, 0.08)' }
        }
      },
      ...props.options
    }
  });
}
</script>
